import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Text from '@ui/text/text/text';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';

type TProjectImageFooterContentProps = {
  label?: string;
};

const ProjectImageFooterContent = ({ label }: TProjectImageFooterContentProps) => {
  return (
    <div className="S1 padding-b-12 padding-h-12 height-100-percent flex flex-column jc-flex-end">
      <div className="flex">
        <TooltipPortal
          delayStart={250}
          keepOpenOnContentHover={false}
          animationType="slide-up"
          verticalOffset={-4}
          tooltipContent={
            <Text className="C2" color="var(--gray-true-dark-100)">
              <div>This project was created from template:</div>
              <div>{label}</div>
            </Text>
          }
        >
          <Container maxWidth="200px" className="flex fd-row jc-flex-start ai-center gap-8">
            <Container className="flex ai-center padding-h-6 gap-4" borderRadius="8px" background="rgba(0, 0, 0, 0.5)">
              <Container className="flex ai-center" width="fit-content" height="100%">
                <Icon name={ICONS.TEMPLATES4} size={16} color="rgb(221,221,221)" />
              </Container>
              <Text className="S2" clamp={1} color="rgb(221,221,221)">
                {label}
              </Text>
            </Container>
          </Container>
        </TooltipPortal>
      </div>
    </div>
  );
};

export default ProjectImageFooterContent;
